import axios from 'axios';
import apiUrl from '../../../constants';

export function update(input, token){
    return axios({
       method: 'post',
       url: apiUrl.api_url + 'updateInvestigate',
       data: input,
       headers: {
         'Authorization': 'Bearer ' + token
       }
     });
}


// WEBPACK FOOTER //
// ./src/services/B2b/services/update.js